export default {
    // 设备查询接口
    autoSearchDevice(params, response) {
        window.vue.$apiAxios.postRequestBody('/videoHost/autoSearchDevice', params, response);
    },
    // 添加设备
    dealVideoHostInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/videoHost/dealVideoHostInfo', params, response);
    },

    // 批量删除设备接口
    batchAddVideoHostInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/videoHost/batchAddVideoHostInfo', params, response);
    },
    // 下传路由
    uploadRouter(params, response) {
        window.vue.$apiAxios.get('/device/uploadRouter', params, response);
    },
    // 下传路由
    uploadRouterEx(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/uploadRouterEx', params, response);
    },
    // 中间件搜素
    autoSearchMiddleware(params, response) {
        window.vue.$apiAxios.postRequestBody('/middleware/autoSearchMiddleware', params, response);
    },
    // 根据设备类型查询设备信息
    queryDeviceByType(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceByType', params, response);
    },
    // 中间件树形查询
    queryMiddlewareTree(params, response) {
        window.vue.$apiAxios.get('/middleware/queryMiddlewareTree', params, response);
    },
    // 树形中间件信息保存
    saveSearchMiddleware(params, response) {
        window.vue.$apiAxios.postRequestBody('/middleware/saveSearchMiddleware', params, response);
    },
    // 下传设置
    uploadServerConfig(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/uploadServerConfig', params, response);
    },
    // 取消设备分配
    batchGetVideoChannelInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/videoHost/batchGetVideoChannelInfo', params, response);
    },
    // 查询设备
    queryDeviceInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceInfoEx', params, response);
    },
    //添加关联
    saveDeviceRelation(params, response) {
        window.vue.$apiAxios.postRequestBody('/fileStorage/saveDeviceRelation', params, response);
    },
    // 删除关联
    deleteDeviceRelation(params, response) {
        window.vue.$apiAxios.postRequestBody('/fileStorage/deleteDeviceRelation', params, response);
    },
    // 查询关联
    queryDeviceRelation(params, response) {
        window.vue.$apiAxios.postRequestBody('/fileStorage/queryDeviceRelation', params, response);
    },
    // 下传文件适配器设置
    uploadFileAdapter(params, response) {
        window.vue.$apiAxios.postRequestBody('/fileAdapter/uploadAdapter', params, response);
    },
    // 查询文件适配器关联设备类型
    queryFileAdatperLinkDevice(params, response) {
        window.vue.$apiAxios.get('/device/queryFileAdatperLinkDevice', params, response);
    },
    // 设备数据导出
    exportDevice(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/device/exportDeviceCsv', params, responseType, response);
    },
    // 导入
    uploadDeviceZip(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/uploadDeviceZip', params, response);
    },
    // 验证唯一性
    checkUnique(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/checkUnique', params, response);
    },

    // 验证设备id是否重复
    checkDeviceIdRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/checkDeviceIdRepeat', params, response);
    },

    // 协议调试订阅接口
    mqSubscribe(params, response) {
        window.vue.$apiAxios.postRequestBody('/devCtlProt/subscribe', params, response);
    },

    // 获取deviceId校验规则
    getDeviceIdValidator(params, response) {
        window.vue.$apiAxios.get('/device/getDeviceIdValidator', params, response);
    },

    // 查询所有设备类型
    queryDeviceType(params, response) {
        window.vue.$apiAxios.get('/device/queryDeviceType', params, response);
    }
};
